import type { FormValue } from "../../redux/interfaces/folder.types";

export const HIDDEN_OCR_FIELDS = new Set([
  "first_name",
  "second_name",
  "first_last_name",
  "second_last_name",
  "curp",
  "rfc",
  "birth_date",
  "nationality",
  "gender",
  "street",
  "exterior_number",
  "interior_number",
  "postal_code",
  "neighborhood",
  "city",
  "state",
]);

export function getResolvedOcrFieldKeys(fields: FormValue[] = []): Set<string> {
  return new Set(
    fields
      .filter((field) => field.prefilled && HIDDEN_OCR_FIELDS.has(field.key))
      .map((field) => field.key),
  );
}
